import { EOnboardingStep } from 'enums';
import { useFetchOnboardingQuery } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';

export const useOnboarding = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = {}, isError, ...rest } = useFetchOnboardingQuery({ orgSlug });

  const {
    status = null,
    building_id: buildingId = null,
    zone_id: zoneId = null,
    employee_id: employeeId = null,
  } = data;

  const onboarding = {
    status: status || (isError ? EOnboardingStep.COMPLETED : EOnboardingStep.SETUP_BUILDING),
    buildingId,
    zoneId,
    employeeId,
  };

  return { data: onboarding, isError, ...rest };
};
